export class Constants {
  static readonly backgroundColor = { light: 0xe5e5e5, dark: 0x4c4c4c };
  static readonly meshColour = { light: 0xdddddd, dark: 0x222222 };
  static readonly altMeshColour = { light: 0xd5d5d5, dark: 0x444444 };
}
